import React, { Component } from "react";

import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CSpinner,
  CRow,
  CCol,
  CCardBody,
  CCard,
  CCardFooter,
  CPagination,
  CTooltip
} from "@coreui/react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";
import { Node } from "slate";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import { descricaoEmTextoPlano } from "../../utils/descricaoAtividade";

const appRoot = document.getElementById("root");

class ChooseNodeModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      // name: "",
      // description: "",
      // discipline_id: "",
      creating: false,
      // contentList: [],
      currentPage: 1,
      maxItems: 8,
      selected: null
    };

    this.el = document.createElement("div");
    this.error = this.error.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    appRoot.appendChild(this.el);

    let obj = {
      user_id: this.props.user.user.id,
      ability_id: 0,
      difficulty_level_id: 0,
      year: 0,
      type_id: 0
    };

    axios
      .post(`${URL.api}activity/activity/list`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        // A descrição chega em quatro formatos (ver `utils/descricaoAtividade.js`) e
        // aqui ela é só o texto que o professor lê para escolher. Uma atividade-trilha
        // aparecer nesta lista é CORRETO — ela é uma atividade —, e é justamente por
        // isso que este ponto precisa da guarda: com `description` null, o `substring`
        // que havia aqui estourava e o modal de escolher nó não abria mais.
        //
        // O tratamento vem ANTES do `setState`, e não depois: como estava, a lista era
        // guardada no state e só então os itens eram mutados no lugar, o que não
        // dispara renderização — a primeira pintura mostrava o JSON cru do editor, e o
        // texto limpo só aparecia se algo mais renderizasse o modal depois.
        const list = resp.data.data
          .filter(item => [1, 3].includes(item.type_id))
          .map(item => ({
            ...item,
            description: descricaoEmTextoPlano(item.description)
          }));

        this.setState({ list, loading: false });
      });
  }

  selectActivity = () => {
    if (!this.state.selected) {
      this.props.onClose();
    }

    const selectedItem = this.state.list.find(
      item => item.id === this.state.selected
    );

    const activity = {
      ...selectedItem,
      items: selectedItem.items.map(item => ({
        ...item,
        type_color: undefined,
        type_name: undefined,
        type_icon: undefined,
        type: {
          activity: true,
          color: item.type_color,
          content: true,
          deleted_at: null,
          description: "",
          icon: item.type_icon,
          id: item.type_id,
          image: "content/types/listaQuestoes.png",
          name: item.type_name
        }
      }))
    };

    this.props.onSelect(activity);
  };

  createActivity = obj => {
    axios
      .post(`${URL.api}activity/activity/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            axios
              .get(`${URL.api}activity/trail/showActivity/${resp.data.data}`, {
                headers: { authorization: `Bearer ${this.props.user.token}` }
              })
              .then(
                resp => {
                  if (resp.data.success) {
                    this.setState({ creating: false });
                    this.props.onCreate(resp.data.data);
                  } else {
                    this.setState({ creating: false });
                    this.error("Não foi possível obter os dados da atividade!");
                  }
                },
                () => {
                  this.setState({ creating: false });
                  this.error("Não foi possível obter os dados da atividade!");
                }
              );
          } else {
            this.setState({ creating: false });
            this.error("Não foi possível salvar a atividade!");
          }
        },
        () => {
          this.setState({ creating: false });
          this.error("Não foi possível salvar a atividade!");
        }
      );
  };

  componentWillUnmount() {
    appRoot.removeChild(this.el);
  }

  serialize = nodes => nodes.map(n => Node.string(n)).join("\n");

  render() {
    return ReactDOM.createPortal(
      <CModal
        show={this.props.show}
        onClose={() => this.props.onClose()}
        size="lg"
        centered
        style={{ overflow: "visible" }}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>Escolher atividade</CModalTitle>
        </CModalHeader>
        <CModalBody style={{ overflow: "visible" }}>
          {this.state.loading ? (
            <div className="h-100 w-100 d-flex align-items-center justify-content-center p-4">
              <CSpinner size="md" color="secondary" />
            </div>
          ) : (
            <>
              <CRow>
                {this.state.list
                  .slice(
                    (this.state.currentPage - 1) * this.state.maxItems,
                    this.state.currentPage * this.state.maxItems
                  )
                  .map((activity, index) => (
                    <CCol key={index} sm="12" lg="6">
                      <CCard
                        className="cursor"
                        style={
                          this.state.selected === activity.id
                            ? {
                                background: "rgb(214, 235, 255)",
                                borderColor: "rgb(176, 205, 233)",
                                transition: "0.15s"
                              }
                            : {
                                transition: "0.15s"
                              }
                        }
                        onClick={() =>
                          this.setState(state => ({
                            selected:
                              state.selected === activity.id
                                ? null
                                : activity.id
                          }))
                        }
                      >
                        <CCardBody
                          className="d-flex align-items-center"
                          style={{ wordBreak: "break-word" }}
                        >
                          <div className="d-flex flex-column justify-content-center align-items-start flex-1 w-100 text-ellipsis">
                            <div className="w-100 d-flex justify-content-between align-items-center text-ellipsis">
                              <h5
                                className="text-overflow m-0 font-weight-semibold text-ellipsis"
                                style={{ wordBreak: "break-all" }}
                              >
                                {activity.name}
                              </h5>
                            </div>
                            <div className="text-muted small mt-1 w-100 text-ellipsis">
                              {/* {this.serialize(JSON.parse(activity.description))} */}
                              {/* {activity.description} */}
                              {activity.description?.includes('[{"type"')
                                ? this.serialize(
                                    JSON.parse(activity.description)
                                  )
                                : activity.description}
                            </div>
                          </div>
                        </CCardBody>
                        {activity.items.length !== 0 && (
                          <CCardFooter
                            className="d-flex align-items-center justify-content-start overflow-hidden"
                            style={
                              this.state.selected === activity.id
                                ? {
                                    background: "rgb(214, 235, 255)",
                                    borderColor: "rgb(176, 205, 233)",
                                    transition: "0.15s"
                                  }
                                : { transition: "0.15s" }
                            }
                          >
                            <div className="d-flex" style={{ flex: 1 }}>
                              {activity.items.map(item => (
                                <CTooltip key={item.id} content={item.name}>
                                  <div
                                    className={`activity-item-icon activity-item-icon-${item.type_color}`}
                                  >
                                    <i
                                      className={`fa fa-${item.type_icon}`}
                                    ></i>
                                  </div>
                                </CTooltip>
                              ))}
                            </div>
                          </CCardFooter>
                        )}
                      </CCard>
                    </CCol>
                  ))}
              </CRow>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <CPagination
                  className="m-0"
                  addListClass="m-0"
                  activePage={this.state.currentPage}
                  pages={
                    Math.ceil(this.state.list.length / this.state.maxItems) || 1
                  }
                  onActivePageChange={page =>
                    this.setState({ currentPage: page })
                  }
                  doubleArrows={false}
                />
                <CButton
                  color="primary"
                  className="d-flex justify-content-center align-items-center"
                  onClick={() => this.selectActivity()}
                  disabled={this.state.creating}
                >
                  <>
                    <span style={this.state.creating ? { opacity: 0 } : null}>
                      Selecionar
                    </span>
                    {this.state.creating && (
                      <CSpinner
                        size="sm"
                        color="white"
                        style={{ position: "absolute" }}
                      />
                    )}
                  </>
                </CButton>
              </div>
            </>
          )}
        </CModalBody>
      </CModal>,
      this.el
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ChooseNodeModal);
